<template>
  <div class="referred" style="width: 100%">
    <v-card-text>
      <v-row class="report-date-picker">
        <div class="col-5">
          <label class="from">از تاریخ</label>
          <date-picker v-model="start_date"></date-picker>
        </div>
        <div class="col-5">
          <label class="to">تا تاریخ</label>
          <date-picker v-model="end_date"></date-picker>
        </div>
        <div class="col-2">
          <label class="to"><br></label>
        </div>
      </v-row>
      <div class="req-list">
        <div :class="'req-card '+card_style(item)" style="padding: 2px"
             v-on:click="get_leave_images(item)"

             v-for="item in request_items"
             :key="item.Id">
          <div>
            <div class="row ">

              <div class="col-6">

                <div
                  class="req-name"
                >درخواست کننده: {{item.UserName}}</div>
              </div>
              <div class="col-6">

                <div
                  class="req-name"
                >شماره درخواست: {{item.LeaveCode}}</div>
              </div>
              <div class="col-6">

                <div
                  class="req-name"
                >نوع درخواست: {{morakhasi_type_list.filter(x=>x.value==item.LeaveType)[0].label}}</div>
              </div>
              <div class="col-6">

                <div
                  class="req-name"
                >جانشین: {{item.SuccessorName}}</div>

              </div>
              <div class="col-6">

                <div
                  class="req-name"
                >از تاریخ: {{get_date_time(item.FromDate)}}</div>
              </div>
              <div class="col-6">

                <div
                  class="req-name"
                >تا تاریخ: {{get_date_time(item.ToDate)}}</div>
              </div>


              <div class="col-12">
                <div

                  class="req-name"
                  v-text="item.LeaveDesc"
                ></div>
              </div>
              <div class="col-12">
                <div
                  v-if="item.FirstAccepted==''"
                  class="req-name"
                >در انتظار تایید</div>
                <div
                  v-if="item.FirstAccepted!='' && item.SecondAccepted==''"
                  class="req-name"
                >در انتظار تاییدیه دوم</div>
                <div
                  v-if="item.FirstAccepted!='' && item.SecondAccepted!=''"
                  class="req-name"
                >تایید شده</div>
              </div>
            </div>

          </div>

        </div>
      </div>
      <infinite-loading @infinite="infiniteHandler" v-if="show_loading">
        <div slot="no-more">{{ $t('no_records') }}</div>
      </infinite-loading>

      <v-dialog
        v-model="morakhasi_status_dialog"
        max-width="290"
        fullscreen
        hide-overlay
      >

        <v-card class="category-modal">
          <v-card-title class="headline">{{$t('information')}}</v-card-title>
          <v-card-text>
              <v-row>
                <v-select
                  outlined
                  :items="status_list"
                  :label="$t('NewStatusChangeStatus')"
                  single-line
                  item-text="label"
                  item-value="value"
                  v-model="selected_status_for_change"
                />
              </v-row>
              <v-row>

                <v-textarea
                  outlined

                  bordered
                  :label="$t('summary')"
                  v-model="status_summary"
                />
              </v-row>
              <v-row>

                 <v-col @click="open_image(img.ImagePath)" v-for="img in selected_leave_images" cols="6"><img
                      width="100%" height="auto" :src="img.ImagePath"></v-col>
              </v-row>
          </v-card-text>
          <v-card-actions class="">
            <v-spacer></v-spacer>

            <v-btn
              class="cancle-btn"
              text
              @click="morakhasi_status_dialog = false"
            >{{ $t('close') }}
            </v-btn>

            <v-btn
              class="cancle-btn"
              text
              @click="go_to_finalize()"
            >ثبت وضعیت
            </v-btn>

          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-card-text>
    <v-row>
      <v-col>
        <v-btn v-on:click="go_to_add_morakhasi()" class="width-100-p" color="primary">درخواست مرخصی</v-btn>
      </v-col>
    </v-row>
  </div>

</template>
<script>
  import InfiniteLoading from 'vue-infinite-loading'

  import Treeselect, {ASYNC_SEARCH} from '@riophae/vue-treeselect'
  // import the styles
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'

  import {bus} from '../../main'
  import {longClickDirective} from 'vue-long-click'
  import Vue from 'vue'
  import mapboxgl from "mapbox-gl";

  import VueSignaturePad from 'vue-signature-pad'
  Vue.use(VueSignaturePad)

  const longClickInstance = longClickDirective({delay: 500, interval: 5000})
  Vue.directive('longclick', longClickInstance)
  const simulateAsyncOperation = fn => {
    setTimeout(fn, 200)
  }
  import moment from 'moment-jalaali'

  export default {
    props: [
      'passing_data'
    ],

    data() {
      return {
        start_date:'',
        end_date:'',
        morakhasi_type_list:[
          {label:'انتخاب کنید',value:0},
          {label:'ساعتی ',value:1},
          {label:'استحقاقی ',value:2},
          {label:'استعلاجی',value:3},
          {label:'دون حقوق',value:4}],
        signature_options: {
          dotSize: (0.5 + 2.5) / 2,
          minWidth: 0.5,
          maxWidth: 2.5,
          throttle: 16,
          minDistance: 5,
          backgroundColor: 'rgb(255,255,255)',
          penColor: 'black',
          velocityFilterWeight: 0.7,
          onBegin: () => {
          },
          onEnd: () => {
          }
        },
        dialog_model: false,
        status_summary: '',
        active_tab: 0,
        selected_status_for_change: 0,
        morakhasi_status_dialog: false,
        selected_product_info: {},
        list: [],
        status_list: [{label:'تایید درخواست',value:1},{label:'رد درخواست',value:2}],
        errors: [],
        post_items: [],
        selected_post: 0,
        dialog_factor: false,
        enable_finalize: false,
        selected_branch: 0,
        request_items: [],
        last_request_items: [],
        request_statuses: [],
        show_loading: false,
        page: 0,
        request_summary: '',
        selected_request: null,
        selected_user: null,
        disable_click: false,
        category_items: [],
        selected_category: 0,
        selected_leave_images:[],
        selected_leave_id:-1,
        normalizer_requests(node) {
          return {
            id: node.Id,
            label: node.Title,
          }
        },
        normalizer_persons(node) {
          return {
            id: node.Id,
            label: node.UserName,
          }
        },
        first: true,
      }
    },
    components: {
      InfiniteLoading,
      Treeselect
    },
    watch: {
      selected_category: function (val) {
        this.selected_request = null
        this.selected_user = null
      },
      start_date: function () {
        this.get_pre_requests(0)
      },
      end_date: function () {
        this.get_pre_requests(0)
      },

    },
    mounted() {
      this.start_date = moment().utc().add(-7, 'day').format('jYYYY/jMM/jDD');
      this.end_date = moment().utc().format('jYYYY/jMM/jDD');

      this.get_pre_requests();
    },

    methods: {
      get_date_time(date){
        return moment(date).format('jYYYY/jM/jD HH:mm');
      },
      get_tab_style(index) {
        if (index == this.active_tab) {
          return 'blue'
        } else {
          return 'white'
        }
      },
      set_active_tab(index) {
        this.active_tab = index;
      },
      go_to_add_morakhasi(){
        this.$router.push({name:'AddMorakhasi'})
      },
      get_pre_requests($state) {
        // this.request_items = [];
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        const send_data = {
          UserId: user_id,
          PersonId: user_id,
          fDate:this.start_date,
          tDate:this.end_date,
          // Count: this.page,
        }
        // GetLeaveDataRpt => UserId PersonId fDate tDate
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetLeaveDataRpt', send_data, {})
          .then(response => {
            self.request_items = []
            if (response.data.error == 0) {
              self.request_items=(JSON.parse(response.data.items))
              console.log("my status", self.request_items)

            }
          }).catch(e => {
          this.errors.push(e)
        })
      },
      get_leave_images(item) {
        var self = this
self.selected_leave_id = item.LeaveId

        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        const send_data = {
          UserId: user_id,
          LeaveId: item.LeaveId,
          // Count: this.page,
        }
        // GetLeaveDataRpt => UserId PersonId fDate tDate
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetLeaveImages', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
             self.selected_leave_images = JSON.parse(response.data.items)
              self.selected_leave_images.forEach(function (val) {
                val.ImagePath = "https://"+val.ImagePath
              })
              self.goToDetail(item)
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },
      infiniteHandler($state) {
        var self = this
        if (this.first) {
          // $state.loaded();
          setTimeout(() => {
            $state.loaded()
          }, 1000)
          return false
        }

        console.log('hiii' + self.last_request_items.length)
        setTimeout(() => {
          // if (self.last_request_items>0 ) {
          self.page += 1
          self.get_pre_requests($state)
          // $state.loaded();
          //
          // } else {
          //   $state.complete();
          //   console.log("completed")
          // }
        }, 1000)
      },
      open_image(img) {
        window.open(img, '_blank')
      },
      goToDetail(item) {
        if (this.disable_click) {
          return;
        }
        console.log("go to detail worked", item)
        // if (item.related_products != null) {
        this.selected_product_info = item;
        this.morakhasi_status_dialog = true;
        // }

      },
      long_click(item) {
        var self = this;
        if (item.selected == null) {
          item.selected = true
          console.log("long click worked")

        } else {
          item.selected = null
        }
        this.disable_click = true
        setTimeout(function () {
          self.disable_click = false

        }, 1000)

        if (this.request_items.filter(x => x.selected == true).length > 0) {
          this.enable_finalize = true;
        } else {
          this.enable_finalize = false;

        }
        this.$forceUpdate()
      },
      card_style(item) {
        if (item.selected) {
          return "blue";

        } else {
          return "";

        }
      },
      go_to_finalize() {
        var self = this;
        var array = this.request_items.filter(x => x.selected == true);
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log(array)
        const send_data = {
          LeaveId: self.selected_leave_id,
          StId: this.selected_status_for_change,
          Desc: this.status_summary,
          UserId: user_id,
        };

        this.axios.post('/AddLeaveStatus', send_data, {})
          .then(response => {
            if(array.length-1 == index_item){
              bus.$emit('show_toast', [2000, response.data.msg])
              // self.dialog_model = false
              this.morakhasi_status_dialog = false;

              self.get_pre_requests()
              self.enable_finalize = false;

            }else{
              self.go_to_finalize(index_item+1)
            }
          }).catch(e => {
          this.errors.push(e)
        })

      },
      undo () {
        this.$refs.signaturePad.clearSignature()
      },
      dataURLtoFile (dataurl, filename) {
        var arr = dataurl.split(',')
        var mime = arr[0].match(/:(.*?);/)[1]
        var bstr = atob(arr[1])
        var n = bstr.length
        var u8arr = new Uint8Array(n)

        while (n--) {
          u8arr[n] = bstr.charCodeAt(n)
        }

        return new File([u8arr], filename, { type:mime })
      },

    }
  }
</script>
<style>
  .v-application .headline {
    font-size: 1rem !important;
    font-weight: 400;
    line-height: 2rem;
    letter-spacing: normal !important;
    font-family: "IRANSans" !important;
  }
</style>
